<template>
  <ModalDeliveryDetails
    v-show="showModalDeliveryDetail"
    @close="hideSelectedDeliveryDetails"
    :delivery="deliverySelected"
  />
  <div class="main">
    <Title title="Entregas" />
    <div class="wrapper-deliveries">
      <div class="above-table">
        <Searcher v-model:search="query" />
        <StandardButton
          :buttonLabel="'Crear entrega'"
          @click="goToDeliveryOption"
        />
      </div>
      <div class="wrapper-table">
        <table class="table-users">
          <thead>
            <tr>
              <th>Fecha de creación</th>
              <th>Nombre</th>
              <th>Cliente</th>
              <th>Detalles</th>
              <th>Reenviar correo</th>
              <th>Obtener link</th>
            </tr>
          </thead>
          <tbody v-for="(delivery, index) in filteredDeliveries" :key="index">
            <tr>
              <td>{{ delivery.deliveryDate }}</td>
              <td>{{ delivery.name }}</td>
              <td>{{ delivery.client }}</td>
              <td>
                <img
                  src="assets/administrator/Details.svg"
                  alt="details"
                  class="icon-table"
                  @click="getDetailsTransaction(delivery)"
                />
              </td>
              <td>
                <img
                  src="assets/administrator/Email.svg"
                  alt="email"
                  class="icon-table"
                />
              </td>
              <td>
                <img
                  src="assets/administrator/Link.svg"
                  alt="link"
                  class="icon-table"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Title from "../layoutAdmin/components/Title.vue";
import Searcher from "@/components/commons/controls/AdminSearcher.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { deliveriesUse } from "../deliveries/use/deliveriesUse";
import ModalDeliveryDetails from "./components/ModalDeliveryDetails.vue";
import { Delivery } from "@/business/deliveries/domain/deliveries";

export default defineComponent({
  name: "DeliveriesView",
  components: { Title, Searcher, StandardButton, ModalDeliveryDetails },
  setup() {
    const {
      goToDeliveryOption,
      deliveries,
      query,
      filteredDeliveries,
      showSelectedDeliveryDetails,
      showModalDeliveryDetail,
      hideSelectedDeliveryDetails,
      deliverySelected,
    } = deliveriesUse();

    async function getDetailsTransaction(delivery: Delivery) {
      await showSelectedDeliveryDetails(delivery);
    }

    return {
      goToDeliveryOption,
      deliveries,
      query,
      filteredDeliveries,
      getDetailsTransaction,
      showModalDeliveryDetail,
      hideSelectedDeliveryDetails,
      deliverySelected,
    };
  },
});
</script>


<style scoped lang="scss">
@import "src/ux/admin/deliveries/styles/deliveriesStyle";
</style>
